"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LinkWrapper_1 = require("./LinkWrapper");
exports.LinkWrapper = LinkWrapper_1.default;
//# sourceMappingURL=index.js.map